var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { currentDateKey, keyToDate } from '../../date/date-picker-calculations';
import '../../month/inner-month-picker/inner-month-picker.lit';
import { monthDateToKey } from '../../month/month-picker-calculations';
import { normalizeLocalMonth } from '../date-types';
import { getMonthNames } from '../display';
import styles from '../sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../sds-datepicker-item/sds-datepicker-item.lit';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * Control represents a calendar: year, month and day pickers with navigation between them
 */
let SdsCalendar = (() => {
    var _SdsCalendar_currentDay_accessor_storage, _SdsCalendar_weekNumbers_accessor_storage, _SdsCalendar_perWeekHover_accessor_storage, _SdsCalendar_navigationState_accessor_storage, _SdsCalendar__year_accessor_storage, _SdsCalendar__month_accessor_storage, _SdsCalendar_yearPageNavigation_accessor_storage, _SdsCalendar_pageMonth_accessor_storage, _SdsCalendar_pageYear_accessor_storage, _SdsCalendar_monthNames_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-calendar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let _weekNumbers_decorators;
    let _weekNumbers_initializers = [];
    let _weekNumbers_extraInitializers = [];
    let _perWeekHover_decorators;
    let _perWeekHover_initializers = [];
    let _perWeekHover_extraInitializers = [];
    let _navigationState_decorators;
    let _navigationState_initializers = [];
    let _navigationState_extraInitializers = [];
    let __year_decorators;
    let __year_initializers = [];
    let __year_extraInitializers = [];
    let __month_decorators;
    let __month_initializers = [];
    let __month_extraInitializers = [];
    let _yearPageNavigation_decorators;
    let _yearPageNavigation_initializers = [];
    let _yearPageNavigation_extraInitializers = [];
    let _pageMonth_decorators;
    let _pageMonth_initializers = [];
    let _pageMonth_extraInitializers = [];
    let _pageYear_decorators;
    let _pageYear_initializers = [];
    let _pageYear_extraInitializers = [];
    let _monthNames_decorators;
    let _monthNames_initializers = [];
    let _monthNames_extraInitializers = [];
    let _set_locale_decorators;
    var SdsCalendar = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsCalendar_currentDay_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _currentDay_initializers, currentDateKey())));
            _SdsCalendar_weekNumbers_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, _weekNumbers_initializers, false)));
            _SdsCalendar_perWeekHover_accessor_storage.set(this, (__runInitializers(this, _weekNumbers_extraInitializers), __runInitializers(this, _perWeekHover_initializers, false)));
            _SdsCalendar_navigationState_accessor_storage.set(this, (__runInitializers(this, _perWeekHover_extraInitializers), __runInitializers(this, _navigationState_initializers, 'SelectDate')));
            _SdsCalendar__year_accessor_storage.set(this, (__runInitializers(this, _navigationState_extraInitializers), __runInitializers(this, __year_initializers, void 0)));
            _SdsCalendar__month_accessor_storage.set(this, (__runInitializers(this, __year_extraInitializers), __runInitializers(this, __month_initializers, void 0)));
            _SdsCalendar_yearPageNavigation_accessor_storage.set(this, (__runInitializers(this, __month_extraInitializers), __runInitializers(this, _yearPageNavigation_initializers, void 0)));
            _SdsCalendar_pageMonth_accessor_storage.set(this, (__runInitializers(this, _yearPageNavigation_extraInitializers), __runInitializers(this, _pageMonth_initializers, void 0)));
            _SdsCalendar_pageYear_accessor_storage.set(this, (__runInitializers(this, _pageMonth_extraInitializers), __runInitializers(this, _pageYear_initializers, void 0)));
            this.dateMapper = __runInitializers(this, _pageYear_extraInitializers);
            _SdsCalendar_monthNames_accessor_storage.set(this, __runInitializers(this, _monthNames_initializers, getMonthNames('en', 'short')));
            this._locale = (__runInitializers(this, _monthNames_extraInitializers), 'en');
            this.changeYearPage = (event) => {
                this.changeYearPageBy(event.detail.step);
            };
            // region render
            this.yearPageChangedHandler = (event) => {
                this.yearPageNavigation.startYear = event.detail.firstYearInPage;
                this.yearPageNavigation.endYear = event.detail.lastYearInPage;
            };
            this.dateSelect = (event) => {
                this.dispatchEvent(new CustomEvent(SdsCalendar.SELECT_EVENT, {
                    detail: Object.assign({}, event.detail),
                }));
            };
            this.weekSelect = (event) => {
                this.dispatchEvent(new CustomEvent(SdsCalendar.WEEK_SELECT_EVENT, {
                    detail: Object.assign({}, event.detail),
                }));
            };
            this.itemHoverHandler = (event) => {
                this.dispatchEvent(new CustomEvent(SdsCalendar.HOVER_EVENT, {
                    detail: Object.assign({}, event.detail),
                }));
            };
            this.handleMonthChange = (e) => {
                this.pageMonth = e.detail.month;
                this.navigateTo('SelectDate');
                this.dispatchMonthSelect();
            };
            this.yearSelect = (e) => {
                this.pageYear = e.detail.year;
                this.navigateTo('SelectMonth');
                this.dispatchYearSelect();
            };
            this.nextMonth = () => {
                this.pageMonth++;
                if (this.pageMonth === 13) {
                    this.pageMonth = 1;
                    this.pageYear++;
                    this.requestUpdate('pageYear', this.pageYear - 1);
                }
                this.syncMappers();
            };
            this.prevMonth = () => {
                this.pageMonth--;
                if (this.pageMonth === 0) {
                    this.pageMonth = 12;
                    this.pageYear--;
                    this.requestUpdate('pageYear', this.pageYear + 1);
                }
                this.syncMappers();
            };
        }
        get currentDay() { return __classPrivateFieldGet(this, _SdsCalendar_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsCalendar_currentDay_accessor_storage, value, "f"); }
        get weekNumbers() { return __classPrivateFieldGet(this, _SdsCalendar_weekNumbers_accessor_storage, "f"); }
        set weekNumbers(value) { __classPrivateFieldSet(this, _SdsCalendar_weekNumbers_accessor_storage, value, "f"); }
        get perWeekHover() { return __classPrivateFieldGet(this, _SdsCalendar_perWeekHover_accessor_storage, "f"); }
        set perWeekHover(value) { __classPrivateFieldSet(this, _SdsCalendar_perWeekHover_accessor_storage, value, "f"); }
        get navigationState() { return __classPrivateFieldGet(this, _SdsCalendar_navigationState_accessor_storage, "f"); }
        set navigationState(value) { __classPrivateFieldSet(this, _SdsCalendar_navigationState_accessor_storage, value, "f"); }
        get _year() { return __classPrivateFieldGet(this, _SdsCalendar__year_accessor_storage, "f"); }
        set _year(value) { __classPrivateFieldSet(this, _SdsCalendar__year_accessor_storage, value, "f"); }
        get _month() { return __classPrivateFieldGet(this, _SdsCalendar__month_accessor_storage, "f"); }
        set _month(value) { __classPrivateFieldSet(this, _SdsCalendar__month_accessor_storage, value, "f"); }
        get yearPageNavigation() { return __classPrivateFieldGet(this, _SdsCalendar_yearPageNavigation_accessor_storage, "f"); }
        set yearPageNavigation(value) { __classPrivateFieldSet(this, _SdsCalendar_yearPageNavigation_accessor_storage, value, "f"); }
        get pageMonth() { return __classPrivateFieldGet(this, _SdsCalendar_pageMonth_accessor_storage, "f"); }
        set pageMonth(value) { __classPrivateFieldSet(this, _SdsCalendar_pageMonth_accessor_storage, value, "f"); }
        get pageYear() { return __classPrivateFieldGet(this, _SdsCalendar_pageYear_accessor_storage, "f"); }
        set pageYear(value) { __classPrivateFieldSet(this, _SdsCalendar_pageYear_accessor_storage, value, "f"); }
        get monthNames() { return __classPrivateFieldGet(this, _SdsCalendar_monthNames_accessor_storage, "f"); }
        set monthNames(value) { __classPrivateFieldSet(this, _SdsCalendar_monthNames_accessor_storage, value, "f"); }
        set locale(value) {
            if (value) {
                this._locale = value;
                const oldValue = this.monthNames;
                this.monthNames = getMonthNames(value, 'short');
                this.requestUpdate('monthNames', oldValue);
            }
        }
        // endregion
        render() {
            return html `
            <div class="sds-date-picker">${this.renderNavigation()} ${this.renderCalendar()}</div>
        `;
        }
        navigateTo(navigationState) {
            const oldValue = this.navigationState;
            this.navigationState = navigationState;
            this.requestUpdate('navigationState', oldValue);
        }
        /**
         * state mapper for date, this value is delegated to sds-month-page-view
         */
        setDateStateMapper(stateMapper) {
            this.dateMapper = stateMapper;
            this.syncMappers();
        }
        /**
         * state mapper for week, this value is delegated to sds-month-page-view
         */
        setWeekStateMapper(stateMapper) {
            this.weekMapper = stateMapper;
            this.syncMappers();
        }
        /**
         * state mapper for month, this value is delegated to sds-month-page-view
         */
        setMonthStateMapper(stateMapper) {
            this.monthMapper = stateMapper;
            this.syncMappers();
        }
        /**
         * state for year, this value is delegated to sds-year-page-view
         */
        setYearStateMapper(stateMapper) {
            this.yearMapper = stateMapper;
            this.syncMappers();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        setPageIndex(year, month) {
            this.pageYear = year;
            this.pageMonth = month;
        }
        updatePageIndex(yearDiff, monthDiff) {
            const [year, month] = normalizeLocalMonth(this.pageYear + yearDiff, this.pageMonth + monthDiff);
            this.pageYear = year;
            this.pageMonth = month;
        }
        firstUpdated() {
            if (this.currentDay) {
                const [year, month] = keyToDate(this.currentDay);
                if (this.pageYear === undefined) {
                    this.pageYear = year;
                }
                if (this.pageMonth === undefined) {
                    this.pageMonth = month;
                }
            }
        }
        updated() {
            this.syncMappers();
            this.setYearViewPage();
        }
        renderNavigation() {
            switch (this.navigationState) {
                case 'SelectDate':
                    return this.renderDateNavigation();
                case 'SelectMonth':
                    return this.renderMonthNavigation();
                case 'SelectYear':
                    return this.renderYearNavigation();
            }
        }
        renderDateNavigation() {
            return html `
            <div class="sds-date-picker-toolbar">
                <sds-button
                    id="prev-month-button"
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_left_thin"
                    @click="${this.prevMonth}"
                ></sds-button>
                <div class="sds-date-picker-toolbar__section">
                    <sds-button
                        id="select-month"
                        label="${this.getMonthName(this.pageMonth)}"
                        type="tertiary"
                        size="sm"
                        @click="${() => this.navigateTo('SelectMonth')}"
                    ></sds-button>
                    <sds-button
                        id="select-year"
                        label="${this.pageYear}"
                        type="tertiary"
                        size="sm"
                        @click="${() => this.navigateTo('SelectYear')}"
                    ></sds-button>
                </div>
                <sds-button
                    id="next-month-button"
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_right_thin"
                    @click="${this.nextMonth}"
                ></sds-button>
            </div>
        `;
        }
        renderMonthNavigation() {
            return html `
            <div class="sds-date-picker-toolbar">
                <sds-button
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_left_thin"
                    @click="${() => --this.pageYear}"
                ></sds-button>
                <sds-button
                    id="select-year"
                    label="${this.pageYear}"
                    type="tertiary"
                    size="sm"
                    @click="${() => this.navigateTo('SelectYear')}"
                ></sds-button>
                <sds-button
                    class="sds-date-picker-toolbar__icon"
                    type="secondary"
                    size="md"
                    icon="arrow_right_thin"
                    @click="${() => ++this.pageYear}"
                ></sds-button>
            </div>
        `;
        }
        renderYearNavigation() {
            return html `
            <sds-year-page-navigation
                @sds.year-page-navigation.page-changed="${this.changeYearPage}"
            >
            </sds-year-page-navigation>
        `;
        }
        renderCalendar() {
            switch (this.navigationState) {
                case 'SelectDate':
                    return this.renderDateView();
                case 'SelectMonth':
                    return this.renderMonthView();
                case 'SelectYear':
                    return this.renderYearView();
            }
        }
        renderDateView() {
            return html `
            <sds-month-view
                pageMonth="${this.pageMonth}"
                pageYear="${this.pageYear}"
                locale="${this._locale}"
                currentDay="${this.currentDay}"
                ?week-numbers="${this.weekNumbers}"
                ?per-week-hover="${this.perWeekHover}"
                @sds.sds-month-view.select="${this.dateSelect}"
                @sds.sds-month-view.week.select="${this.weekSelect}"
                @sds.sds-month-view.hover="${this.itemHoverHandler}"
            >
            </sds-month-view>
        `;
        }
        renderMonthView() {
            const [currentYear, currentMonth] = keyToDate(this.currentDay);
            return html `
            <sds-month-page-view
                @sds.month-page-view.select="${this.handleMonthChange}"
                currentMonth="${monthDateToKey(currentYear, currentMonth)}"
                pageYear="${this.pageYear}"
            >
            </sds-month-page-view>
        `;
        }
        renderYearView() {
            const [currentYear] = keyToDate(this.currentDay);
            return html `
            <sds-year-page-view
                @sds.year-page-view.select="${this.yearSelect}"
                @sds.year-page-view.page-changed="${this.yearPageChangedHandler}"
                currentYear="${currentYear}"
            >
            </sds-year-page-view>
        `;
        }
        changeYearPageBy(diff) {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view')) === null || _b === void 0 ? void 0 : _b.goByPage(diff);
        }
        getMonthName(month) {
            return this.monthNames[month - 1];
        }
        dispatchMonthSelect() {
            this.dispatchEvent(new CustomEvent(SdsCalendar.MONTH_SELECT_EVENT, {
                detail: {
                    month: [this.pageYear, this.pageMonth],
                },
            }));
        }
        dispatchYearSelect() {
            this.dispatchEvent(new CustomEvent(SdsCalendar.YEAR_SELECT_EVENT, {
                detail: {
                    year: this.pageYear,
                },
            }));
        }
        setYearViewPage() {
            var _a, _b;
            (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-year-page-view')) === null || _b === void 0 ? void 0 : _b.openPageFor(this.pageYear);
        }
        syncMappers() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this.dateMapper) {
                (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-month-view')) === null || _b === void 0 ? void 0 : _b.setDateStateMapper(this.dateMapper);
            }
            if (this.weekMapper) {
                (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('sds-month-view')) === null || _d === void 0 ? void 0 : _d.setWeekStateMapper(this.weekMapper);
            }
            if (this.monthMapper) {
                (_f = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('sds-month-page-view')) === null || _f === void 0 ? void 0 : _f.setMonthStateMapper(this.monthMapper);
            }
            if (this.yearMapper) {
                (_h = (_g = this.shadowRoot) === null || _g === void 0 ? void 0 : _g.querySelector('sds-year-page-view')) === null || _h === void 0 ? void 0 : _h.setYearStateMapper(this.yearMapper);
            }
        }
    };
    _SdsCalendar_currentDay_accessor_storage = new WeakMap();
    _SdsCalendar_weekNumbers_accessor_storage = new WeakMap();
    _SdsCalendar_perWeekHover_accessor_storage = new WeakMap();
    _SdsCalendar_navigationState_accessor_storage = new WeakMap();
    _SdsCalendar__year_accessor_storage = new WeakMap();
    _SdsCalendar__month_accessor_storage = new WeakMap();
    _SdsCalendar_yearPageNavigation_accessor_storage = new WeakMap();
    _SdsCalendar_pageMonth_accessor_storage = new WeakMap();
    _SdsCalendar_pageYear_accessor_storage = new WeakMap();
    _SdsCalendar_monthNames_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsCalendar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _currentDay_decorators = [property()];
        _weekNumbers_decorators = [property({ type: Boolean, attribute: 'week-numbers' })];
        _perWeekHover_decorators = [property({ type: Boolean, attribute: 'per-week-hover' })];
        _navigationState_decorators = [state()];
        __year_decorators = [state()];
        __month_decorators = [state()];
        _yearPageNavigation_decorators = [query('sds-year-page-navigation')];
        _pageMonth_decorators = [state()];
        _pageYear_decorators = [state()];
        _monthNames_decorators = [state()];
        _set_locale_decorators = [property()];
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, _weekNumbers_decorators, { kind: "accessor", name: "weekNumbers", static: false, private: false, access: { has: obj => "weekNumbers" in obj, get: obj => obj.weekNumbers, set: (obj, value) => { obj.weekNumbers = value; } }, metadata: _metadata }, _weekNumbers_initializers, _weekNumbers_extraInitializers);
        __esDecorate(_classThis, null, _perWeekHover_decorators, { kind: "accessor", name: "perWeekHover", static: false, private: false, access: { has: obj => "perWeekHover" in obj, get: obj => obj.perWeekHover, set: (obj, value) => { obj.perWeekHover = value; } }, metadata: _metadata }, _perWeekHover_initializers, _perWeekHover_extraInitializers);
        __esDecorate(_classThis, null, _navigationState_decorators, { kind: "accessor", name: "navigationState", static: false, private: false, access: { has: obj => "navigationState" in obj, get: obj => obj.navigationState, set: (obj, value) => { obj.navigationState = value; } }, metadata: _metadata }, _navigationState_initializers, _navigationState_extraInitializers);
        __esDecorate(_classThis, null, __year_decorators, { kind: "accessor", name: "_year", static: false, private: false, access: { has: obj => "_year" in obj, get: obj => obj._year, set: (obj, value) => { obj._year = value; } }, metadata: _metadata }, __year_initializers, __year_extraInitializers);
        __esDecorate(_classThis, null, __month_decorators, { kind: "accessor", name: "_month", static: false, private: false, access: { has: obj => "_month" in obj, get: obj => obj._month, set: (obj, value) => { obj._month = value; } }, metadata: _metadata }, __month_initializers, __month_extraInitializers);
        __esDecorate(_classThis, null, _yearPageNavigation_decorators, { kind: "accessor", name: "yearPageNavigation", static: false, private: false, access: { has: obj => "yearPageNavigation" in obj, get: obj => obj.yearPageNavigation, set: (obj, value) => { obj.yearPageNavigation = value; } }, metadata: _metadata }, _yearPageNavigation_initializers, _yearPageNavigation_extraInitializers);
        __esDecorate(_classThis, null, _pageMonth_decorators, { kind: "accessor", name: "pageMonth", static: false, private: false, access: { has: obj => "pageMonth" in obj, get: obj => obj.pageMonth, set: (obj, value) => { obj.pageMonth = value; } }, metadata: _metadata }, _pageMonth_initializers, _pageMonth_extraInitializers);
        __esDecorate(_classThis, null, _pageYear_decorators, { kind: "accessor", name: "pageYear", static: false, private: false, access: { has: obj => "pageYear" in obj, get: obj => obj.pageYear, set: (obj, value) => { obj.pageYear = value; } }, metadata: _metadata }, _pageYear_initializers, _pageYear_extraInitializers);
        __esDecorate(_classThis, null, _monthNames_decorators, { kind: "accessor", name: "monthNames", static: false, private: false, access: { has: obj => "monthNames" in obj, get: obj => obj.monthNames, set: (obj, value) => { obj.monthNames = value; } }, metadata: _metadata }, _monthNames_initializers, _monthNames_extraInitializers);
        __esDecorate(_classThis, null, _set_locale_decorators, { kind: "setter", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsCalendar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.SELECT_EVENT = 'sds.calendar.select';
    _classThis.WEEK_SELECT_EVENT = 'sds.calendar.week.select';
    _classThis.HOVER_EVENT = 'sds.calendar.hover';
    _classThis.MONTH_SELECT_EVENT = 'sds.calendar.month.select';
    _classThis.YEAR_SELECT_EVENT = 'sds.calendar.year.select';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsCalendar = _classThis;
})();
export { SdsCalendar };
